<template>
	<c-window ref="window" :title="false" width="550" mask-close>
		<div class="list" :style="{'max-height': listHeight + 'px'}">
			<data-filter-config ref="dataFilter"></data-filter-config>
		</div>

		<template #foot>
			<div class="flex-end" style="width: 100%; margin-right: 5px;">
				<c-checkbox v-model="save">保存过滤规则</c-checkbox>
			</div>
		</template>

		<template #button>
			<c-button @click="$refs.dataFilter.reset()">重置</c-button>
			<c-button color="main" @click="submitHandle">确定</c-button>
		</template>
	</c-window>
</template>

<script>
	import dataFilterConfig from './data_filter.vue'

	export default {
		name: 'dataFilter',

		components: {
			dataFilterConfig
		},

		props: {
			workType: [Number, String],
			viewId: [Number, String]
		},

		data() {
			let storage = JSON.parse(localStorage.getItem(this.workType) || '{}');
			return {
				save: !!storage.df,
				listHeight: 0
			}	
		},

		methods: {
			open({follow, config}) {
				let rect = (follow.$el || follow).getBoundingClientRect();
				this.listHeight = Math.min(500, window.innerHeight - rect.bottom - 50);
				this.$refs.dataFilter.set(this.workType, config || []);
				this.$refs.window.open(follow);
			},

			submitHandle() {
				let config = this.$refs.dataFilter.get();
				this.$emit('resolve', config, this.save);
				this.$refs.window.close();
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.list {
		max-height: 500px;
		overflow: auto;
	}

	>>> .c-form {
		padding-right: 10px;

		.c-input,
		.c-select:not([auto-height]),
		.c-datetime {
			height: 32px;
		}

		.c-select-tag {
			padding: 3px 0;
		}

		.filter-time-text {
			line-height: 30px;
		}

		.filter-delete {
			margin-top: 3px;
		}
	}
</style>
